import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
  SelectionProviderChildProps,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import {
  FlowFieldsByIdQuery,
  FlowFieldsByIdQuery_flows_outputSteps_outputFieldsConnection_nodes,
  FlowFieldsByIdQueryVariables,
} from '../../../gen-src/queries/FlowFieldsByIdQuery';
import { FlowOutputFieldSortOrder } from '../../../gen-src/queries/globalTypes';
import { FlowFieldsByIdQueryGql } from '../../queries/FlowFieldsByIdQueryGql';
import { iconForField } from '../field/functions/FieldFunctions';
import { FieldsValidSortFields } from '../sorting/sortProviders/FieldsGridSortProvider';
import { FlowFieldsDisplayGrid, FlowFieldsDisplayGridRowData } from './FlowFieldsDisplayGrid';

export type QueryVariables = FlowFieldsByIdQueryVariables;
export type QueryResults = FlowFieldsByIdQuery;
export type QueryResultListNode = FlowFieldsByIdQuery_flows_outputSteps_outputFieldsConnection_nodes;
export type GridRowData = FlowFieldsDisplayGridRowData;

export type FlowFieldsQueryGridProps =
  SelectionProviderChildProps &
  GridSortProps<FieldsValidSortFields> & {
    readonly flowVizportalUrlId: string;
    readonly selectedOutputStepId: string;
    readonly rowCount: number | null;
  };

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.flows && resultData.flows[0] &&
    resultData.flows[0].outputSteps[0] && resultData.flows[0].outputSteps[0].outputFieldsConnection;
}

export function mapResultNode(node: QueryResultListNode, resultData: QueryResults): GridRowData {
  if (node.__typename === 'FlowFieldOutputField') {
    const field = node && node.field;
    return {
      flowVizportalUrlId: resultData.flows[0].vizportalUrlId,
      id: node.id,
      name: node.name,
      fieldIcon: node && node.field && iconForField(node.field),
      sheetCount: field && field.downstreamSheetsConnection ? field.downstreamSheetsConnection.totalCount : null,
    };
  } else {
    const column = node && node.column;
    return {
      flowVizportalUrlId: resultData.flows[0].vizportalUrlId,
      id: node.id,
      name: node.name,
      fieldIcon: null,
      remoteType: column ? column.remoteType : undefined,
      sheetCount: column && column.downstreamSheetsConnection ? column.downstreamSheetsConnection.totalCount : null,
    };
  }
}

export function FlowFieldsQueryGrid(props: FlowFieldsQueryGridProps): JSX.Element {

  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={FlowFieldsByIdQueryGql}
      partialQueryVariables={{
        flowVizportalUrlId: props.flowVizportalUrlId,
        selectedOutputStepId: props.selectedOutputStepId,
        orderBy: props.orderBy as FlowOutputFieldSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={mapResultNode}
    >
      {({ rowStore }) => (
        <FlowFieldsDisplayGrid
          rowStore={rowStore}
          selectedKeys={props.selectedKeys}
          updateSelectionForKey={props.updateSelectionForKey}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
